/**
 * @generated SignedSource<<7911126ef17b58ffc93762f4e6fcfc54>>
 * @relayHash 4db5964fda1ef7ad6bb403c6a9420d56
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HelpObjectStoreRequestTypeSearchStrategy = "JIRA_ISSUE_BASED_SEARCH" | "JIRA_KEYWORD_BASED" | "SEARCH_PLATFORM_KEYWORD_BASED" | "SEARCH_PLATFORM_KEYWORD_BASED_ER" | "%future added value";
export type requestFormsSearchQuery$variables = {
  cloudId: string;
  helpCenterAri?: string | null | undefined;
  limit: number;
  portalId?: string | null | undefined;
  queryTerm: string;
};
export type requestFormsSearchQuery$data = {
  readonly helpObjectStore_searchRequestTypes: {
    readonly __typename: "HelpObjectStoreRequestTypeSearchResults";
    readonly results: ReadonlyArray<{
      readonly id: string;
      readonly metadata: {
        readonly isExternal: boolean;
        readonly searchStrategy: HelpObjectStoreRequestTypeSearchStrategy;
      };
      readonly " $fragmentSpreads": FragmentRefs<"requestFormItemFragmentV2">;
    }>;
  } | {
    readonly __typename: "HelpObjectStoreSearchError";
    readonly extensions: ReadonlyArray<{
      readonly errorType: string | null | undefined;
      readonly statusCode: number | null | undefined;
    }>;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type requestFormsSearchQuery = {
  response: requestFormsSearchQuery$data;
  variables: requestFormsSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "helpCenterAri"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "limit"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "portalId"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "queryTerm"
},
v5 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  },
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "portalId",
    "variableName": "portalId"
  },
  {
    "kind": "Variable",
    "name": "queryTerm",
    "variableName": "queryTerm"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "concreteType": "HelpObjectStoreRequestTypeMetadata",
  "kind": "LinkedField",
  "name": "metadata",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isExternal"
    },
    {
      "kind": "ScalarField",
      "name": "searchStrategy"
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "message"
},
v10 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v11 = {
  "kind": "ScalarField",
  "name": "errorType"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "requestFormsSearchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "FragmentSpread",
                    "name": "requestFormItemFragmentV2"
                  }
                ]
              }
            ],
            "type": "HelpObjectStoreRequestTypeSearchResults"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              }
            ],
            "type": "HelpObjectStoreSearchError"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "requestFormsSearchQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "LinkedField",
        "name": "helpObjectStore_searchRequestTypes",
        "plural": false,
        "selections": [
          (v6/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "HelpObjectStoreRequestTypeSearchResult",
                "kind": "LinkedField",
                "name": "results",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "title"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "displayLink"
                  }
                ]
              }
            ],
            "type": "HelpObjectStoreRequestTypeSearchResults"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v9/*: any*/),
              {
                "kind": "LinkedField",
                "name": "extensions",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/)
                ]
              }
            ],
            "type": "HelpObjectStoreSearchError"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "7a42fa0dfd03d21b39be3663005026111bd9c1c5eab237277bed34ecd93481f9",
    "metadata": {},
    "name": "requestFormsSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6a4749a62d9236563bcbeca7d18c02eb";

export default node;
